//import React from "react"
import React, { Component } from "react";
import UpdateAddItemDetails from "./UpdateAddItemDetails" // import row item details 
import DatePicker from "./DatePicker" // import DatePicker
import axios from 'axios';
import withRouter from './withRouter';
//import { withRouter } from "react-router-dom";
import Navbar from '../Navbar';
import { format } from 'date-fns';
import swal from 'sweetalert';
import { Link, useNavigate,useParams} from 'react-router-dom';
import { id } from "date-fns/locale";

class UpdateChallanDetails extends React.Component {
    // state define 
    
     
    constructor(props) {
        super(props)
        this.state = {
            addMore: [{ index: Math.random(), distin: "", sn: "", descriptive: "", test: "", pltonns: "", swltonns: "",swltonns2:"" }],//item list
            date: "",
            party_code: "",
            party_name: "",
            remarks: "",
            ship_name:"",
            serial_type:"",
            vertical_name: "",
            address: "",
            associate_code: "",
            tested: "",
            user_id:localStorage.getItem("auth_id"),
            party_code_list:[],
            posts:[],
            series:[],
            error_list: [],
        };
    }
     

    
    // handle input changes
    handleChange = (e) => {
        if (["distin", "sn", "descriptive", "test", "pltonns", "swltonns","swltonns2"].includes(e.target.name)) {
            let addMore = [...this.state.addMore]
            addMore[e.target.dataset.id][e.target.name] = e.target.value;
        } else {
            this.setState({ [e.target.name]: e.target.value })
        }
    }

    // party name populate using party code 
    handlePartyCode = (e) => {
        const partyCode = e.target.value;
        axios.get(`/api/party_name/${partyCode}`).then(res=>{
            if(res.data.status===200){
                let PName= res.data.customer[0].name;
                this.setState({party_name:PName})
                document.getElementById("party_name").value = PName;
            }
            });
    }

    // handle input changes
    handleChangeDate = (e) => {

        var dateToday = new Date();
        // console.log(dateToday)
    }

    //  Add new row Item details
    addNewRow = () => {
        this.setState((prevState) => ({
            addMore: [...prevState.addMore, { index: Math.random(), distin: "", sn: "", descriptive: "", test: "", pltonns: "", swltonns: "",swltonns2: "" }],
        }));
    }
 
    componentDidMount(){
        fetch('https://cert.geekay.biz/backend/api/view-customer').then(resp=>resp.json())
        // fetch('/api/view-customer').then(resp=>resp.json())
        .then(resp=>this.setState({posts:resp.customer}))

        axios.get(`/api/get_serial`).then(res=>{
            if(res.data.status===200){
             
               this.setState({series:res.data.series});
            }
            });
        let id  = this.props.params.id;

        axios.get(`/api/edit_challan/${id}`).then(res=>{
            if(res.data.status===200){
               this.setState(res.data.chalans);
               this.setState(res.data.chalanseqence);
               this.setState(res.data.serial_type);
               // this.setState({add});
               this.setState({addMore:res.data.itemDetails});
               // console.log("fljsdfhjsd");
               // console.log(this.state.serial_type);
            }
        });

    }

    // update input action call backend Api and store data
    handleUpdate = (e) => {
        e.preventDefault();
    
        let data = this.state;
        // console.log(data);

        let id  = this.props.params.id;
        axios.put(`/api/update_challan/${id}`,data).then(res =>{
            // console.log('api',res.data)
        if(res.data.status===200){
            window.location.href = '/certificates/show_chalans';
        }
        else if(res.data.status===400){
            this.setState({...this.state, error_list:res.data.errors});
        }
        });

    }
    

    //  delete addMore detals Row
    clickOnDelete(record) {
        this.setState({
            addMore: this.state.addMore.filter(r => r !== record)
        });
    }

    // create form field data 
    render() {
          //console.log('Props:', this.props)
            //console.log('Props:', this.props)
           //const { id } = this.props.match.params;
            //console.log('user=',user);
         let { addMore } = this.state //collected data add more all field 
         
        return (
            
           <div className="content">
            <Navbar />
                
                <form id= "edit_challan" onSubmit={this. handleUpdate} onChange={this.handleChange} >
                    <div className="row" style={{ marginTop: 20, width: "97%" }}>
                        // <div className="col-sm-1"></div>
                        <div className="col-sm-12" style={{ marginLeft: 40 }}>
                            <div className="card">
                                <div className="card-header"><h4><b>Update Challan Details</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Verticle Name</label>
                                                <select name="vertical_name" id="vertical_name" className="form-control" value={this.state.vertical_name} >
                                                    <option >--vertical_name --</option>
                                                    {/* <option value="Industrial-MZ">Industrial-MZ</option>
                                                    <option value="Industrial-MA">Industrial-MA</option> */}
                                                    <option value="IDLR">IDLR</option>
                                                </select>
                                                <span style={{color: "red"}} >{this.state.error_list.verticle_type}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Party Code</label>
                                                <select name="party_code" id="party_code" className="form-control"  value={this.state.party_code} onChange={this.handlePartyCode}>
                                                    <option value="" >-- Party Code --</option>
                                                    {this.state.posts.map(post=><option key={post.pcode}>{post.pcode}{post.title}</option>)}
                                                </select>
                                                <span style={{color: "red"}} >{this.state.error_list.party_code}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Party Name</label>
                                                <input type="taxt" name="party_name" id="party_name"  value={this.state.party_name}  className="form-control" placeholder="Party Name" />
                                                <span style={{color: "red"}} >{this.state.error_list.party_name}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Associate Code</label>
                                                <input type="taxt" name="associate_code" value={this.state.associate_code} id="associate_code"  className="form-control" placeholder="Associate Code" />
                                                <span style={{color: "red"}} >{this.state.error_list.associate_code}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Address</label>
                                                <input type="taxt" name="address" id="address"  value={this.state.address} className="form-control" placeholder="Address" />
                                                <span style={{color: "red"}} >{this.state.error_list.address}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                            <label className="required" style={{ marginBottom: "7px" }}>Date</label>
                                                {/* <input type="date"  name="date" id="date" value={this.state.date} className="form-control" placeholder="Enter Date" min={startdate} max={enddate}/> */}
                                                <span id="dataRemark" style={{color: "red",display:"none"}} disabled={false} >Not open Month plz maintain Month master</span>
                                                {/* --------------------get month  ----------------*/}
                                                <DatePicker date={this.datepicker}   />
                                                <span style={{color: "red"}} >{this.state.error_list.date}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group">
                                                <label className="required" style={{ marginBottom: "7px" }}>Tested</label>
                                                <select name="tested" className="form-control"  value={this.state.tested} >
                                                    <option>-- Select status --</option>
                                                    <option value="O.K">O.K</option>
                                                    <option value="Rejected">Rejected</option>
                                                </select>
                                                <span style={{color: "red"}} >{this.state.error_list.tested}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Remarks</label>
                                                <input type="taxt" name="remarks" id="remarks"  value={this.state.remarks} className="form-control" placeholder="Enter Remarks" />
                                                <span style={{color: "red"}} >{this.state.error_list.remarks}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Series</label>
                                                <select  id="serial_type"  name="serial_type" className="form-control" value={this.state.serial_type} >
                                                    <option value="">-- Series Name --</option>
                                                    {this.state.series.map(post=><option key={post.pcode}>{post.series_name}</option>)}
                                                </select>
                                                <span style={{color: "red"}} >{this.state.error_list.serial_type}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Ship Name</label>
                                                <input type="text" name="ship_name" id="ship_name" value={this.state.ship_name} className="form-control" placeholder="Ship Name" />
                                                <span style={{color: "red"}} >{this.state.error_list.Ship_name}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Official Number</label>
                                                <input type="text" name="official_number" id="official_number" value={this.state.official_number} className="form-control" placeholder="Official Number" />
                                                <span style={{color: "red"}} >{this.state.error_list.official_number}</span>
                                            </div>
                                        </div>
                                        {/* <div className="col-sm-4">
                                            <div className="form-group ">
                                                <label className="required">Description</label>
                                                <textarea name="description"  id="description" className="form-control"></textarea>
                                            </div>
                                        </div> */}
                                    </div >

                                    {/* --------------------Item details Add more Display data Start ----------------*/}
                                    <table class="table table-bordered" style={{ marginTop: "30px" }}>
                                        <thead>
                                            <tr>
                                                <th scope="col" style={{ width: "15%" }} >Category</th>
                                                <th scope="col" style={{ width: "10%" }}>Distinguish Mark</th>
                                                <th scope="col" style={{ width: "45%" }}>Description/Dimension & Material of Gear/Device</th>
                                                <th scope="col" style={{ width: "10%" }} >Nos. Tests</th>
                                                <th scope="col" style={{ width: "10%" }} >P.L. Tonns</th>
                                                <th scope="col" style={{ width: "10%" }} >SWL Tonns</th>
                                                <th scope="col" style={{ width: "5%" }} >SWL Select</th>
                                                <th scope="col" style={{ width: "2%" }} >#</th>
                                                
                                            </tr>
                                        </thead>
                                    {/* -------------------- Create Add and Delete both Functions Delete row and Add row  ----------------*/}
                                        <tbody>
                                            <UpdateAddItemDetails add={this.addNewRow} delete={this.clickOnDelete.bind(this)} addMore={addMore} /> 
                                        </tbody>
                                    </table>
                                    {/* --------------------Item details Add more Display data End ----------------*/}
                                </div>
                                <div className="card-footer text-center"> <button id="update" type="Update" style={{ backgroundColor: "#A38A00", color: "white" }} className="btn btn-default text-center" disabled={false}>Update</button></div>
                            </div>
                        </div>
                        // <div className="col-sm-1"></div>
                    </div>
                </form>
            </div>
        )
    }
}

export default withRouter(UpdateChallanDetails);
//export default UpdateChallanDetails;